import React from 'react';
import { Button } from '@cad-arc';
import { useIntegratedForm } from '../forms/use-integrated-form';
import { UnitLocationFormType } from './unit-location-form';

export function ClearButton({
    unitId,
    label = 'Clear all',
    size,
}: {
    unitId: number;
    label?: string;
    size?: 'sm' | 'md' | 'lg';
}): React.ReactElement {
    const integratedForm = useIntegratedForm<UnitLocationFormType>();
    return (
        <Button
            onClick={() => {
                integratedForm.form.reset({
                    consolidatedLocationView: undefined,
                    subPremise: '',
                    comments: '',
                    unitId,
                });
            }}
            size={size}
            variant="ghost"
            {...integratedForm.getGenericButtonProps()}
        >
            {label}
        </Button>
    );
}
